export default __webpack_public_path__ + "static/media/ncentiva-loader.1433f469.svg";